module.exports = __webpack_public_path__ + "static/img/fivetigers_th.19ac823.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lucas/fivetigers_th.png
// module id = /dxg
// module chunks = 1